const state = {
    isShow: false,
}

const getters = {
    get_isShow: (state) => {
        return state.isShow;
    },
}

const actions = {
    triggerLoadingBar: (context) => {
        context.commit("TRIGGERLOADINGBAR");
    },
}

const mutations = {
    TRIGGERLOADINGBAR: (state) => {
        state.isShow = !state.isShow;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}